import { createTheme } from "@mui/material";
import { keyboardFocusVisibleSx } from "./utils/a11y.utils";

const theme = createTheme({
  palette: {
    primary: {
      light: "#F3F5FD",
      main: "#3053D3",
    },
    secondary: {
      main: "#FFFFFF",
    },
    error: {
      main: "#C62828",
    },
    success: {
      main: "#20BE79",
      light: "#E9F8F2",
    },
    info: {
      main: "#000000",
    },
    black60: "#5F6368",
    black40: "#6B7280",
    backgroundMobileSubHeader: "#2B3056",
    textBlack: "#111111",
    tagRed: {
      main: "#CA2626",
      light: "#FDEDED",
    },
  },
  typography: {
    fontFamily: "lato"
    // fontFamily: [
    //   "Roboto",
    //   "-apple-system",
    //   "BlinkMacSystemFont",
    //   '"Segoe UI"',
    //   "Arial",
    //   "sans-serif",
    //   '"Apple Color Emoji"',
    //   '"Segoe UI Emoji"',
    //   '"Segoe UI Symbol"',
    // ].join(","),
  },
  components: {
    MuiButtonBase: {
      styleOverrides: {
        root: {
          ...keyboardFocusVisibleSx,
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          minWidth: 24,
          minHeight: 24,
          boxSizing: 'border-box',
          ...keyboardFocusVisibleSx,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          borderRadius: "14px",
          borderColor: "#757575",
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          opacity: 1
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "124px",
          ...keyboardFocusVisibleSx,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: "none",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          ...keyboardFocusVisibleSx,
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          ...keyboardFocusVisibleSx,
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          ...keyboardFocusVisibleSx,
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: "#757575",
          "&.Mui-disabled": {
            color: "#949494",
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          "&::placeholder": {
            color: "#757575",
            opacity: 1,
          },
        },
      },
    },
    MuiListItemAvatar: {
      styleOverrides: {
        root: {
          minWidth: "unset",
        }
      }
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: "unset",
        }
      }
    }
  },
});

export default theme;
